import { Controller } from "@hotwired/stimulus"

// The diagnostic's clock: the exam's minute a question, counting down, and past zero the
// time over budget instead of an end (owner, 2026-10-06). The server's elapsed figure is
// the truth, so a reload or a slow page never gives time back.
export default class extends Controller {
  static targets = ["display", "label"]
  static values = { elapsed: Number, budget: Number, overLabel: String }

  connect() {
    this.loadedAt = Date.now()
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const elapsed = this.elapsedValue + Math.floor((Date.now() - this.loadedAt) / 1000)
    const left = this.budgetValue - elapsed
    if (left >= 0) {
      this.displayTarget.textContent = format(left)
      return
    }

    this.labelTarget.textContent = this.overLabelValue
    this.displayTarget.textContent = `+${format(-left)}`
    this.element.dataset.over = "true"
  }
}

function format(seconds) {
  const minutes = Math.floor(seconds / 60)
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`
}
